import * as TariffActions from "./tariff.actions";

import {createReducer, on} from "@ngrx/store";
import {TenTariff} from "../../_models/tariff.models";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const tariffFeatureKey = 'tariff';

export interface TariffState {
    tariffs: Record<string, TenTariff>,
    selectedApartment: string,
    listLoading: DahLoadingType,
}

export const initialState = {
    tariffs: {},
    selectedApartment: "",
    listLoading: 'listLoading' as DahLoadingType,
};

export const tariffReducer = createReducer(
    initialState,

    on(TariffActions.loadTariff, (state, payload) => ({
        ...state,
        listLoading: payload.apartmentId in state.tariffs ? undefined : 'listLoading' as DahLoadingType,
    })),

    on(TariffActions.loadTariffSuccess, (state, payload) => {
        return {
            ...state,
            tariffs: {
                ...state.tariffs,
                [payload.apartmentId]: payload.tariff,
            },
            listLoading: undefined
        };
    }),

    on(TariffActions.loadTariffFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(TariffActions.setApartment, (state, payload) => ({
        ...state,
        selectedApartment: payload.apartmentId
    })),

    on(SetAllInitialStates, () => ({...initialState}))
);
